'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

require('flickity-imagesloaded');

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarCarousel = function CarCarousel(el) {
  (0, _classCallCheck3.default)(this, CarCarousel);

  this.el = el;

  var slide = (0, _functional.getElements)('[data-el="car-carousel.slide"]');

  if (slide.length === 1) return;

  var initialIndex = (0, _functional.getElements)('.car-Carousel_Item').findIndex(function (el) {
    return el.dataset.initialIndex === 'true';
  });
  var carCarousel = new _flickity2.default((0, _functional.getElement)('[data-carousel="carousel"]', { context: this.el }), {
    wrapAround: true,
    pageDots: false,
    cellAlign: 'center',
    adaptiveHeight: false,
    autoPlay: 5000,
    pauseAutoPlayOnHover: true,
    prevNextButtons: false,
    setGallerySize: true,
    imagesLoaded: true,
    touchVerticalScroll: false,
    dragThreshold: 30,
    initialIndex: initialIndex
  });

  // Recalculate height after each video has loaded
  var carouselItems = (0, _functional.getElements)('[data-el="car-carousel.slide"] video', {
    context: this.el
  });

  carouselItems.forEach(function (video) {
    video.addEventListener('loadedmetadata', function () {
      carCarousel.resize();
    });
  });

  carCarousel.on('dragStart.el', function (event, pointer) {
    document.ontouchmove = function (e) {
      e.preventDefault();
    };
  });

  carCarousel.on('dragEnd.flickity', function (event, pointer) {
    document.ontouchmove = function (e) {
      return true;
    };
  });

  window.BAO = window.BAO || {};
  window.BAO.carCarousel = carCarousel;
};

exports.default = CarCarousel;